__turbopack_context__.v({
  "content": "Message-module__nSr70a__content",
  "header": "Message-module__nSr70a__header",
  "icon": "Message-module__nSr70a__icon",
  "iconMessage": "Message-module__nSr70a__iconMessage",
  "info": "Message-module__nSr70a__info",
  "list": "Message-module__nSr70a__list",
  "message": "Message-module__nSr70a__message",
  "negative": "Message-module__nSr70a__negative",
  "orange": "Message-module__nSr70a__orange",
  "positive": "Message-module__nSr70a__positive",
  "purple": "Message-module__nSr70a__purple",
  "red": "Message-module__nSr70a__red",
  "warning": "Message-module__nSr70a__warning",
  "yellow": "Message-module__nSr70a__yellow",
});
